<div class="card small-card text-center" (click)="openUrlInNewTab(redirectUrl)">
  <img [src]="logoFile == null ? 'assets/navigation/dashboard (1)-1@2x.png' : logoFile" class="card-img-top small-image" alt="..." style="padding: 0 10px;">
  <div class="card-body">
    <h3 *ngIf="!description"  class="card-title" title="{{name.length > 26 ? name : ''}}">{{ (name.length > 26) ? (name | slice:0:26) + '..' : (name) }}</h3>
    <h3 *ngIf="description" class="card-text" title="{{description.length > 26 ? description : ''}}">{{ (description.length > 26) ? (description | slice:0:26) + '..' : (description) }}</h3>
  </div>
</div>
